<template>
  <div>
    <div>
      <div>
        <v-layout row wrap dense class="ma-0">
          <v-flex xs8>
            <div class="headline primary--text">DEPA ADMIN - ขั้นตอนโครงการ</div>
          </v-flex>
          <v-flex xs4 style="display: flex; align-items: flex-end; justify-content: flex-end">
            <div class="text-xs-right" style="display: flex; align-items: flex-end">
              <v-btn
                small
                :style="`color: ${$vuetify.theme.primary};  text-transform: capitalize;`"
                :color="`color: ${$vuetify.theme.primary}`"
                outline
                ><i class="fas fa-search mr-1"></i>{{ $t('Search') }}</v-btn
              >
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="desserts"
          :pagination.sync="pagination"
          select-all
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:headers="props">
            <tr style="background-color: #152d53; color: white">
              <th
                style="background-color: #152d53; color: yellow"
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : '',
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon style="color: yellow" small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr class="py-3 depatable">
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td class="text-xs-left">
                <div v-if="props.item.process && props.item.process.length" class="py-2">
                  <div v-for="(item, k) in props.item.process" :key="k">
                    {{ item }}
                  </div>
                </div>
                <div v-else>-</div>
              </td>
              <td class="text-xs-left">
                <div v-if="props.item.step && props.item.step.length" class="py-2">
                  <div v-for="(item, k) in props.item.step" :key="k">
                    {{ item }}
                  </div>
                </div>
                <div v-else>-</div>
              </td>
              <td class="text-xs-left">
                <div v-if="props.item.form && props.item.form.length" class="py-2">
                  <div v-for="(item, k) in props.item.form" :key="k">
                    {{ item }}
                  </div>
                </div>
                <div v-else>-</div>
              </td>

              <td>
                <v-btn icon outline>
                  <i :color="$vuetify.theme.primary" class="fas fa-pencil-alt"></i>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div>
          <v-dialog v-model="editModal" persistent width="850px">
            <project-type-edit
              @closemodal="closemodal"
              @saveedit="saveedit"
              v-if="editModal"
              v-model="inputEdit"
            ></project-type-edit>
          </v-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectTypeEdit from './ProjectTypeEdit.vue'

export default {
  components: { ProjectTypeEdit },

  data() {
    return {
      test: false,
      pagination: {
        sortBy: 'name',
      },
      inputEdit: {},
      editModal: false,
      desserts: [
        {
          id: '00000001',
          category: 'มาตรการ',
          type: 'Fund',
          detail: 'xxxxxxxxx',

          process: ['1 สมัคร', '2 พิจารณา'],
          step: ['1 สมัคร', '2 พิจารณา'],
          form: ['Form 01', 'Form 01'],
        },
        {
          id: '00000002',
          category: 'มาตรการ',
          type: 'Fund',
          detail: 'xxxxxxxxx',

          process: ['1 สมัคร', '2 พิจารณา'],
          step: ['1 สมัคร', '2 พิจารณา'],
          form: ['Form 01', 'Form 01'],
        },
      ],
      headers: [
        {
          text: 'TypeID',
          align: 'center',
          value: 'id',
        },
        {
          text: 'Processes',
          align: 'center',
          value: 'type',
        },
        {
          text: 'Step',
          align: 'center',
          value: 'step',
        },
        {
          text: 'Form',
          align: 'center',
          value: 'form',
        },
        {
          text: '',
          align: 'center',
          value: '',
        },
      ],
    }
  },
  methods: {
    statusColor(status) {
      if (status == 'Active') return 'green'
      else if (status == 'Inactive') return 'red'
    },
    saveedit(item) {
      var index = this.desserts.findIndex((el) => el.id == item.id)
      this.desserts[index] = item
      this.editModal = false
    },
    closemodal() {
      this.editModal = false
    },
    showEdit(item) {
      this.inputEdit = item
      this.editModal = true
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
  },
}
</script>

<style lang="scss">
.depatable td {
  vertical-align: baseline;
}
</style>


// WEBPACK FOOTER //
// src/components/view/projectMaster/ProjectStep.vue